var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74845 7.95383C4.97041 7.69921 4.7896 7.30165 4.4518 7.30165H3.44044C3.43385 7.20158 3.43016 7.10073 3.43016 6.99904C3.43016 4.47919 5.48018 2.42917 8 2.42917C9.21094 2.42917 10.3132 2.90276 11.1318 3.67424L12.5579 2.00586C11.3095 0.863826 9.70288 0.238281 8 0.238281C6.19415 0.238281 4.49639 0.941539 3.21944 2.21845C1.94253 3.49539 1.23927 5.19315 1.23927 6.99901C1.23927 7.10026 1.2418 7.20111 1.2462 7.30162H0.394326C0.0565289 7.30162 -0.124312 7.69917 0.0976804 7.95379L2.0194 10.1581L2.42305 10.6211L3.87228 8.95876L4.74845 7.95383Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9024 6.66732L14.469 5.0232L13.577 4L12.3034 5.46088L11.2516 6.66732C11.0297 6.92194 11.2105 7.3195 11.5483 7.3195H12.5585C12.3932 9.69017 10.412 11.5685 8.00006 11.5685C6.9472 11.5685 5.97649 11.2104 5.20295 10.6098L3.77673 12.2783C4.97153 13.2378 6.44561 13.7593 8.00009 13.7593C9.80595 13.7593 11.5037 13.0561 12.7807 11.7792C13.9817 10.5782 14.675 9.00486 14.7532 7.31953H15.6058C15.9435 7.31949 16.1243 6.92194 15.9024 6.66732Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.fa72098d5b0bf2bea86915f944d4285c.svg";
export { ForwardRef as ReactComponent };